import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { AppState } from 'src/app/store/app.states';
import { getAdminUserInfo } from 'src/app/store/selector/selector';

declare var bootstrap: any;
declare var $: any;  

@Component({
  selector: 'app-admin-cancel-subscription',
  templateUrl: './cancel-subscription.component.html',
  styleUrls: ['./cancel-subscription.component.scss']
})
export class CancelSubscriptionComponent implements OnInit,OnChanges {
  @Input() id:any;
  @Input() table:any;
  @Input() modalid:any;
  @Output() newItemEvent = new EventEmitter<string>();
  submitting=false;
  user:any

  constructor(private store: Store<AppState>, private toastrService: ToastrService, public adminApi: AdminapiService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
    },1000)
  } 

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }

  
  getUserData(){
    this.adminApi.setLoader(true)
    this.store.pipe(select(getAdminUserInfo)).subscribe(data=>{
      this.user = data
      this.adminApi.setLoader(false)
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }

  onSubmit() {
    if (!this.submitting) {
      this.submitting = true;
      this.adminApi.cancelSubscription(this.table,this.id).subscribe((data: any) => {
        if (data.success) {
          this.addNewItem('change')
					this.toastrService.success(data.message);
          $('#'+this.modalid).modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.submitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.submitting=false;
      });
    } 
  }
  
}
